var _path, _linearGradient, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 63.9C14.4 63.9.1 49.6.1 32S14.4.1 32 .1 63.9 14.4 63.9 32 49.6 63.9 32 63.9zm0-57.8C17.7 6.1 6.1 17.7 6.1 32S17.7 57.9 32 57.9 57.9 46.3 57.9 32 46.3 6.1 32 6.1z",
    fill: "#f5f5f5",
    fillOpacity: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 63.928,
    y1: 46.464,
    x2: 29,
    y2: 46.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23d2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#12b9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#05a4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#009de9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63.9c-1.7 0-3-1.3-3-3s1.3-3 3-3c14.3 0 25.9-11.6 25.9-25.9 0-1.7 1.3-3 3-3s3 1.3 3 3c0 17.6-14.3 31.9-31.9 31.9z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.47225aed9c07798b4fd7466d9bd21fa3.svg";
export { ForwardRef as ReactComponent };